import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TourOperatorBookingFareDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Tour Operator Booking Fare")}
      endpoint={`/fares/tour-operator-fares/${props.match.params.id}/`}
      successRoute={reverse("tourOperatorBookingFareList")}
      errorRoute={reverse("tourOperatorBookingFareList")}
    />
  )
}

TourOperatorBookingFareDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
